import {Box, Grid, Typography} from '@mui/material'
import {Link} from 'react-router-dom'
import Button from '@mui/material/Button'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import Masonry from '@mui/lab/Masonry'
import DeckCard from './DeckCard'
import React, {useState} from 'react'
import {Deck} from '../model/models'
import LoadingInline from './LoadingInline'
import AnonAddDeckDialog from './AnonAddDeckDialog'

export interface DeckMasonryProps {
  title: string
  loading: boolean
  decks: Deck[]
  isPublic: boolean
  isAnon: boolean
  onAddPublic: (deckId: number) => void
  isLimited?: boolean
  hidePublicDecksLink?: boolean
}

export default function DeckMasonry(props: DeckMasonryProps) {
  const publicDecksLinkText = props.isLimited ? 'More Public Decks' : 'Public Decks'

  const [loginSignupOpen, setLoginSignupOpen] = useState<boolean>(false)

  const handleAddPublicDeck = async (deckId: number) => {
    props.onAddPublic(deckId)
  }

  const handleAddPublicDeckAnon = (deckId: number) => {
    setLoginSignupOpen(true)
  }

  const closeAnonDialog = () => {
    setLoginSignupOpen(false)
  }
  
  return (
    <>
      <AnonAddDeckDialog deckId={-1} open={loginSignupOpen} handleCloseCancel={closeAnonDialog}/>
      <Grid>
        <Grid container sx={{justifyContent: 'space-between'}}>
          <Typography
            variant="h5"
            gutterBottom
            sx={{my: 2}}>
            {props.title}
          </Typography>
          {!props.hidePublicDecksLink &&
            <Link to="/public-decks" style={{textDecoration: "none", color: "inherit"}}>
              <Box sx={{my: 2}}>
                <Button color="secondary" sx={{textTransform: 'none',}} startIcon={<ArrowForwardIosIcon/>}>{publicDecksLinkText}</Button>
              </Box>
            </Link>}
        </Grid>
        {props.loading && <LoadingInline/>}
        <Grid container spacing={1} sx={{ml: .75}}>
          <Masonry
            component="span" columns={{xs: 2, sm: 4, md: 4}}
            sx={{
              alignContent: 'flex-start'
            }}>
            {props.decks.map(deck =>
              <DeckCard key={deck.id} deck={deck} isPublic={props.isPublic} onAddPublic={props.isAnon ? handleAddPublicDeckAnon : handleAddPublicDeck}/>
            )}
          </Masonry>
        </Grid>
      </Grid>
    </>
  )
}


